import clsx from "clsx";
import type { ReactNode } from "react";

type Tone = "neutral" | "success" | "warning" | "danger" | "info" | "primary";

const TONES: Record<Tone, string> = {
    neutral: "app-content-subtle app-shell-text-muted border app-shell-border",
    success: "bg-[var(--color-success-bg)] text-[var(--color-success-text)] border border-transparent",
    warning: "bg-[var(--color-warning-bg)] text-[var(--color-warning-text)] border border-transparent",
    danger: "bg-[var(--color-error-bg)] text-[var(--color-error-text)] border border-transparent",
    info: "bg-[var(--color-info-bg)] text-[var(--color-info-text)] border border-transparent",
    primary: "app-accent-soft app-accent-text border border-transparent",
};

export interface BadgeProps {
    children: ReactNode;
    tone?: Tone;
    className?: string;
}

export function Badge({ children, tone = "neutral", className }: BadgeProps) {
    return (
        <span
            className={clsx(
                "inline-flex items-center gap-1 rounded-full px-2.5 py-1 text-xs font-semibold",
                TONES[tone],
                className,
            )}
        >
            {children}
        </span>
    );
}
